import {
  FETCH_PAYMENT_PROOFS_REQUEST,
  FETCH_PAYMENT_PROOFS_SUCCESS,
  FETCH_PAYMENT_PROOFS_FAILURE,
  UPDATE_PAYMENT_PROOF_STATUS_REQUEST,
  UPDATE_PAYMENT_PROOF_STATUS_SUCCESS,
  UPDATE_PAYMENT_PROOF_STATUS_FAILURE,
} from "../actions/types";

const initialState = {
  proofs: [],
  total_count: 0,
  page: 1,
  size: 10,
  loading: false,
  error: null,
  message: "",
};

const paymentProofReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fetch Payment Proofs
    case FETCH_PAYMENT_PROOFS_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_PAYMENT_PROOFS_SUCCESS:
      return {
        ...state,
        loading: false,
        proofs: action.payload.proofs,
        total_count: action.payload.total_count,
        page: action.payload.page,
        size: action.payload.size,
        message: "Payment proofs retrieved successfully",
      };

    case FETCH_PAYMENT_PROOFS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Update Payment Proof Status
    case UPDATE_PAYMENT_PROOF_STATUS_REQUEST:
      return { ...state, loading: true, error: null };

    case UPDATE_PAYMENT_PROOF_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        proofs: state.proofs.map((proof) =>
          proof.document_id === action.payload.document_id ? { ...proof, status: action.payload.status } : proof
        ),
        message: "Payment proof status updated successfully",
      };

    case UPDATE_PAYMENT_PROOF_STATUS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default paymentProofReducer;
